module.exports = __webpack_public_path__ + "img/data-item5-2.2ad1105.png";